import Vuex from 'vuex';
import absenceType from '@/planner/store/absenceType';
import dossierDetails from '@/planner/store/dossierDetails';
import workshopPlanning from '@/planner/store/workshopPlanning';
import workshopPlanningUserSettings from '@/planner/store/workshopPlanningUserSettings';
import serviceEvents, { UserLoggedOut } from '@/shared/services/events/serviceEvents';
import vehicle from '@/vehicle/store/vehicle';
import fetch from './fetch';

const store = new Vuex.Store({
  strict: import.meta.env.PROD,
  modules: {
    fetch,
    vehicle,
    absenceType,
    workshopPlanning,
    workshopPlanningUserSettings,
    dossierDetails,
  },
  actions: {
    clear({ commit }) {
      commit('absenceType/clear');
    },
  },
});

serviceEvents.on(UserLoggedOut, () => store.dispatch('clear'));

export default store;